<div class="adduser-container-hgt">
  <jni-bcledger-filter
    #filter
    [bcList]="bcList"
    (bcLedgerFormEvent)="getBcLedgerFormData($event)"
    [bcSelectedId]="''"
    [selectedDateRange]="'Current YTD'"
    [showHeading]="false"
    [showBrandingConsultantDropDown]="brandingConsultantSection"
    [showBrandingConsultantWhoSupportsMeDropDown]="
      showBrandingConsultantWhoSupportsMeDropDown
    "
    [invokeAtLoad]="!brandingConsultantSection"
    [isFromBCLedger]="false"
    [isBAC]="isBAC"
    [isManager]="isManager"
    [overrideManager]="overrideManager"
    [showRemoveFilter]="showRemoveFilter"
    [showSupportDashboardButton]="true"
    [userRole]="userRole"
    [fromManagerView]="true"
    [isSuperManager]="isSuperManager"
    [disableDropDown]="disableDropDown"
    [fromManager]="true"
    [bcSelectedId]="bcSelectedId"
    (removeFilterEvent)="removeFilter($event)"
    (bcSelectedEvent)="bcSelectedEvent()"
    (removeFilterButtonEvent)="removeFilterButtonEvent()"
    (showFilterButton)="showFilterButton()"
    (redirectToSupportDashboard)="
      redirectToSupportDashboard($event)
    "></jni-bcledger-filter>

  <div>
    <p-button label="Generate Pdf" (click)="getManagerReportPdf()" />

    <!--     
    <button class="btn btn btn-primary" (click)="getManagerReportPdf()">
      Generate Pdf
    </button> -->
  </div>

  <div class="row pb-4 mt-3">
    <div class="col-12" *ngIf="isManager">
      <jni-location-wise-q3-grid1
        [grid1]="grid1"
        [location]="location"
        [manager]="this.filter.bcSelectedId || ''"
        [isSuperManager]="isSuperManager"
        [isAdmin]="isAdmin"
        [currentQuarter]="currentQuarter"
        (submitEvent)="onNotesSubmit($event)"></jni-location-wise-q3-grid1>
    </div>
    <div class="col-12 mt-5">
      <jni-location-wise-q3-grid2
        *ngIf="isManager"
        [manager]="this.filter.bcSelectedId || ''"
        [isSuperManager]="isSuperManager"
        [isAdmin]="isAdmin"
        [grid2]="grid2"
        [location]="location"
        [currentQuarter]="currentQuarter"
        (submitEvent)="onNotesSubmit($event)"></jni-location-wise-q3-grid2>
    </div>
  </div>
</div>
